// import { OVERTIME_URL } from '../constants';
// import { apiSlice } from './apiSlice';


// export const overtimeApiSlice = apiSlice.injectEndpoints({
//   endpoints: (builder) => ({
//     // Submit overtime request
//     postOvertime: builder.mutation({
//       query: (overtimeData) => ({
//         url: `${OVERTIME_URL}`,
//         method: 'POST',
//         body: overtimeData,
//       }),
//       invalidatesTags: ['Overtime'],
//     }),
    
//     // Get all overtime requests (for records view) - OLD endpoint without status
//     getOvertimeRequests: builder.query({
//       query: () => ({
//         url: `${OVERTIME_URL}/requests`,
//         method: 'GET',
//       }),
//       providesTags: ['Overtime'],
//     }),

//     // Get all overtime requests WITH status field (NEW - use this!)
//     getOvertimeWithStatus: builder.query({
//       query: () => ({
//         url: `${OVERTIME_URL}/with-status`,
//         method: 'GET',
//       }),
//       providesTags: ['Overtime'],
//     }),

//     // Supervisor: Reject overtime request
//     rejectOvertimeRequest: builder.mutation({
//       query: ({ requestId, rejectReason }) => ({
//         url: `${OVERTIME_URL}/supervisor/reject/${requestId}`,
//         method: 'PUT',
//         body: { rejectReason },
//       }),
//       invalidatesTags: ['Overtime'],
//     }),

//     // Supervisor: Forward overtime request to manager
//     forwardOvertimeRequest: builder.mutation({
//       query: ({ requestId, supervisorNote }) => ({
//         url: `${OVERTIME_URL}/supervisor/forward/${requestId}`,
//         method: 'PUT',
//         body: { supervisorNote },
//       }),
//       invalidatesTags: ['Overtime'],
//     }),

//     // Supervisor: Request technician to reapply
//     requestReapply: builder.mutation({
//       query: ({ requestId, reapplyReason }) => ({
//         url: `${OVERTIME_URL}/supervisor/request-reapply/${requestId}`,
//         method: 'PUT',
//         body: { reapplyReason },
//       }),
//       invalidatesTags: ['Overtime'],
//     }),

//     // Technician: Reapply with updated details
//     reapplyOvertimeWithDetails: builder.mutation({
//       query: ({ requestId, startTime, endTime, totalHours, description }) => ({
//         url: `${OVERTIME_URL}/supervisor/reapply/${requestId}`,
//         method: 'PUT',
//         body: { startTime, endTime, totalHours, description },
//       }),
//       invalidatesTags: ['Overtime'],
//     }),
//   }),
// });

// export const {
//   usePostOvertimeMutation,
//   useGetOvertimeRequestsQuery,
//   useGetOvertimeWithStatusQuery,
//   useRejectOvertimeRequestMutation,
//   useForwardOvertimeRequestMutation,
//   useRequestReapplyMutation,
//   useReapplyOvertimeWithDetailsMutation,
// } = overtimeApiSlice;

import { apiSlice } from './apiSlice';

export const overtimeApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    postOvertime: builder.mutation({
      query: (overtimeData) => ({
        url: `/attendanceservice/api/overtime`,  // ✅ CORRECT
        method: 'POST',
        body: overtimeData,
      }),
      invalidatesTags: ['Overtime'],
    }),
    
    getOvertimeRequests: builder.query({
      query: () => ({
        url: `/attendanceservice/api/overtime/requests`,  // ✅ CORRECT
        method: 'GET',
      }),
      providesTags: ['Overtime'],
    }),

    getOvertimeWithStatus: builder.query({
      query: () => ({
        url: `/attendanceservice/api/overtime/with-status`,  // ✅ CORRECT
        method: 'GET',
      }),
      providesTags: ['Overtime'],
    }),

    rejectOvertimeRequest: builder.mutation({
      query: ({ requestId, rejectReason }) => ({
        url: `/attendanceservice/api/overtime/supervisor/reject/${requestId}`,  // ✅ CORRECT
        method: 'PUT',
        body: { rejectReason },
      }),
      invalidatesTags: ['Overtime'],
    }),

    forwardOvertimeRequest: builder.mutation({
      query: ({ requestId, supervisorNote }) => ({
        url: `/attendanceservice/api/overtime/supervisor/forward/${requestId}`,  // ✅ CORRECT
        method: 'PUT',
        body: { supervisorNote },
      }),
      invalidatesTags: ['Overtime'],
    }),

    requestReapply: builder.mutation({
      query: ({ requestId, reapplyReason }) => ({
        url: `/attendanceservice/api/overtime/supervisor/request-reapply/${requestId}`,  // ✅ CORRECT
        method: 'PUT',
        body: { reapplyReason },
      }),
      invalidatesTags: ['Overtime'],
    }),

    reapplyOvertimeWithDetails: builder.mutation({
      query: ({ requestId, startTime, endTime, totalHours, description }) => {
        console.log("Reapply mutation called with:", { requestId, startTime, endTime, totalHours, description });
        return {
          url: `/attendanceservice/api/overtime/supervisor/reapply/${requestId}`,
          method: 'PUT',
          body: { startTime, endTime, totalHours, description },
        };
      },
      invalidatesTags: ['Overtime'],
    }),

    // Manager: Get all overtime requests
    getManagerOvertimeRequests: builder.query({
      query: () => ({
        url: `/attendanceservice/api/overtime/manager/all-requests`,
        method: 'GET',
      }),
      providesTags: ['Overtime'],
    }),

    // Manager: Approve overtime request (using supervisor endpoint with manager auth)
    approveOvertimeRequest: builder.mutation({
      query: ({ requestId, approvalNote }) => ({
        url: `/attendanceservice/api/overtime/manager/approve/${requestId}`,  // Check if this endpoint exists, else use supervisor forward
        method: 'PUT',
        body: { approvalNote },
      }),
      invalidatesTags: ['Overtime'],
    }),

    // Manager: Reject overtime request (using supervisor endpoints with manager auth)
    rejectOvertimeByManager: builder.mutation({
      query: ({ requestId, rejectionNote }) => ({
        url: `/attendanceservice/api/overtime/supervisor/reject/${requestId}`,  // Manager also uses supervisor endpoint
        method: 'PUT',
        body: { rejectReason: rejectionNote },  // Backend expects "rejectReason" not "rejectionNote"
      }),
      invalidatesTags: ['Overtime'],
    }),

    // Get monthly overtime balance and limits
    getMonthlyOvertimeBalance: builder.query({
      query: () => ({
        url: `/attendanceservice/api/overtime/balance/monthly`,
        method: 'GET',
      }),
      providesTags: ['Overtime'],
    }),

    // Supervisor: Get division-based pending requests
    getSupervisorDivisionRequests: builder.query({
      query: () => ({
        url: `/attendanceservice/api/overtime/supervisor/pending-requests`,
        method: 'GET',
      }),
      providesTags: ['Overtime'],
    }),

    // Manager: Get department-based pending requests
    getManagerDepartmentRequests: builder.query({
      query: () => ({
        url: `/attendanceservice/api/overtime/manager/pending-requests`,
        method: 'GET',
      }),
      providesTags: ['Overtime'],
    }),

    // Admin/Report: Get requests by division
    getOvertimeByDivision: builder.query({
      query: (divisionId) => ({
        url: `/attendanceservice/api/overtime/by-division?divisionId=${divisionId}`,
        method: 'GET',
      }),
      providesTags: ['Overtime'],
    }),

    // Admin/Report: Get requests by department
    getOvertimeByDepartment: builder.query({
      query: (departmentId) => ({
        url: `/attendanceservice/api/overtime/by-department?departmentId=${departmentId}`,
        method: 'GET',
      }),
      providesTags: ['Overtime'],
    }),

    // Get overtime requests by userId (for user details page)
    getOvertimeByUserId: builder.query({
      query: (userId) => ({
        url: `/attendanceservice/api/overtime/technician/${userId}`,
        method: 'GET',
      }),
      providesTags: ['Overtime'],
    }),
  }),
});

export const {
  usePostOvertimeMutation,
  useGetOvertimeRequestsQuery,
  useGetOvertimeWithStatusQuery,
  useRejectOvertimeRequestMutation,
  useForwardOvertimeRequestMutation,
  useRequestReapplyMutation,
  useReapplyOvertimeWithDetailsMutation,
  useGetManagerOvertimeRequestsQuery,
  useApproveOvertimeRequestMutation,
  useRejectOvertimeByManagerMutation,
  useGetMonthlyOvertimeBalanceQuery,
  useGetSupervisorDivisionRequestsQuery,
  useGetManagerDepartmentRequestsQuery,
  useGetOvertimeByDivisionQuery,
  useGetOvertimeByDepartmentQuery,
  useGetOvertimeByUserIdQuery,
} = overtimeApiSlice;